module.exports = __webpack_public_path__ + "img/6513.c11e1731.jpg";